export let CustomerLicenses = {
    'personal': 1,
    'premium': 2,
    'enterprise': 3,
    'trial': 99,
    'demo': 99,
}